<template>
	<section class="file-selector">
		<input class="file-input" @input="fileInput" ref="fileInput" type="file" />
		<div class="file-selected">
            <el-button icon="el-icon-upload" class="w-100" v-if="!showRemoveButton" @click="fileSelect" type="primary">Select Document</el-button>
            <el-button icon="el-icon-delete" :class="currentFile && fileName && !selectedFile ? '' : 'w-100'" v-else type="danger" @click="removeFile">Remove Document</el-button>
            <el-button icon="el-icon-view" v-if="currentFile && fileName && !selectedFile" type="success" @click="viewFile(currentFile)">View Document</el-button>
		</div>
	</section>
</template>
<script>
	export default {
		name: "FileSelector",
		props: {
            currentFile: {
                required: false,
				type: [String, File],
				default: "",
            }
		},
		data() {
			return {
				fileName: '',
                selectedFile: '',
			}
		},
		computed: {
            showRemoveButton() {
                if (!this.fileName) return false
                return true
            }
        },
		methods: {
            viewFile(url) {
                window.open(url, '_blank').focus();
            },
			fileSelect() {
				this.$refs.fileInput.click()
			},
			fileInput() {
				let input = this.$refs.fileInput
				let file = input.files
				if (file && file[0]) {
					this.fileName = file[0].name
                    this.selectedFile = file
				}
			},
            removeFile() {
                this.fileName = ''
                this.selectedFile = ''
                this.$emit("input", 'delete')
            },
		},
		mounted() {

		},
		watch: {
			selectedFile: {
				handler(selectedFile) {
                    let file = selectedFile && selectedFile ? selectedFile : false
                    this.$emit("input", file[0] ? file[0] : "")
				},
				immediate: true,
                deep: true
			},
            currentFile: {
                handler(file) {
					if (file && typeof file !== File) {
						this.fileName = file
					}
				},
				immediate: true,
            },
		},
	}
</script>

<style lang="scss" scoped>
	.file-selector {
        position: relative;

		.file-input {
			display: none;
		}

        .file-selected {
            display: inline;
        }

		.file-options {
			.revert-default {
				cursor: pointer;
			}
		}
	}
</style>
